<template>
  <div class="mb10">
    <table class="w-100">
      <tr class="bg-kplh-primary text-white">
        <td rowspan="2" class="col-1">NO</td>
        <td rowspan="2" class="col-5">PERSYARATAN</td>
        <td class="col-1">BOBOT</td>
        <td class="col-1">NILAI</td>
        <td rowspan="3" class="col-4">PENJELASAN HASIL PENILAIAN</td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td>{{ totalBobot }}</td>
        <!-- <td>{{ totalNilai * totalBobot }}</td> -->
        <td>{{ nilai }}</td>
      </tr>
      <!-- A -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">A</td>
        <td class="col-5">ORGANISASI DAN SUMBER DAYA</td>
        <td class="col-1">{{ bobot_e_1 }}</td>
        <td class="col-1">{{ componentAScore }}</td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan struktur organisasi yang memiliki tanggung jawab KPLH
        </td>
        <td class="col-1">{{ bobot_e_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_1', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub text-white">
        <td class="col-1">B</td>
        <td class="col-5">MANAJEMEN RISIKO</td>
        <td class="col-1">{{ bobot_b_2 }}</td>
        <td class="col-1">{{ componentBScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan hasil identifikasi bahaya dan pengendalian risiko (IBPR) yang masih berlaku
        </td>
        <td class="col-1">{{ bobot_b_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_2', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub text-white">
        <td class="col-1">C</td>
        <td class="col-5">SARANA PRASARANA, INSTALASI & PERALATAN</td>
        <td class="col-1">{{ bobot_i52_1 }}</td>
        <td class="col-1">{{ componentCScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar sarana, prasarana, instalasi dan peralatan (SPIP)
          yang dimiliki perusahaan.
        </td>
        <td class="col-1">{{ bobot_i52_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_1', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub text-white">
        <td class="col-1">D</td>
        <td class="col-5">PROSEDUR KERJA</td>
        <td class="col-1">{{ bobot_i8_1 }}</td>
        <td class="col-1">{{ componentDScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar seluruh prosedur pengendalian operasional yang
          dimiliki perusahaan (seluruh prosedur hingga Analisa Kerja Aman / JSA
          dan Instruksi Kerja Aman).
        </td>
        <td class="col-1">{{ bobot_i8_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_1', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub text-white">
        <td class="col-1">E</td>
        <td class="col-5">ALAT PELINDUNG DIRI</td>
        <td class="col-1">{{ bobot_i9_2 }}</td>
        <td class="col-1">{{ componentEScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan daftar distribusi semua jenis APD, baik APD umum
          maupun APD khusus untuk pekerjaan tertentu.
        </td>
        <td class="col-1">{{ bobot_i9_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i9_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i9_2', '') }}
        </td>
      </tr>

      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          HASIL PENILAIAN TOTAL UNTUK KATEGORI
          {{ kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-') }}
          <br>
          <span class="text-sm">**Nilai kelulusan adalah 75% atau lebih; di bawah itu, tidak memenuhi syarat untuk
            lulus</span>
        </td>
        <td class="text-center">{{ totalResult }} %</td>
        <!-- <td class="text-center">{{ finalScore }} %</td> -->
        <!-- <td class="text-center bg-success">LULUS PRAKUALIFIKASI</td> -->
        <td :class="`text-center ${finalResult && finalResult.indexOf('TIDAK') != -1
          ? 'bg-danger text-white'
          : 'bg-success'
          }`
          ">
          {{ finalResult }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          Catatan
        </td>
        <td colspan="2" class="text-center">{{ kplh && $get(kplh, 'request.kplh_penilaian.catatan', '-') }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: [
    'kplh',
    'finalResult',
    'totalResult',
    'penilaian',
    'bobot',
    'totalNilai',
  ],
  data() {
    return {
      bobot_b_2: 2,
      bobot_e_1: 2,
      bobot_i52_1: 2,
      bobot_i8_1: 4,
      bobot_i9_2: 2,
    };
  },
  computed: {

    componentAScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_e_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_e_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentBScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_b_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_b_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentCScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_i52_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i52_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentDScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 1
      this.penilaian.value_i8_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_i8_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentEScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_i9_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i9_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },

    finalScore() {

      // const nilai = (Number(this.nilai) / Number(this.totalBobot)) * 100
      const nilai = (Number(this.nilai) / Number(this.totalBobot)) * 100
      return nilai.toFixed(2)
    },

    nilai() {
      // const nilai = (Number(this.totalNilai) * Number(this.totalBobot)) / 100
      // return nilai.toFixed(2)

      const nilai = Number(this.componentAScore) + Number(this.componentBScore) + Number(this.componentCScore) + Number(this.componentDScore) + Number(this.componentEScore)
      return nilai.toFixed(2)
    },
    totalBobot() {
      // if ($get(this.penilaian, 'value_b_2', '') == 'N/A') {
      //   this.bobot_b_2 = 0
      // }
      this.penilaian.value_b_2 == 'N/A' ? this.bobot_b_2 = 0 : 0
      this.penilaian.value_e_1 == 'N/A' ? this.bobot_e_1 = 0 : 0
      this.penilaian.value_i52_1 == 'N/A' ? this.bobot_i52_1 = 0 : 0
      this.penilaian.value_i8_1 == 'N/A' ? this.bobot_i8_1 = 0 : 0
      this.penilaian.value_i9_2 == 'N/A' ? this.bobot_i9_2 = 0 : 0

      const total = this.bobot_b_2 + this.bobot_e_1 + this.bobot_i52_1 + this.bobot_i8_1 + this.bobot_i9_2

      return total
    }
  },
  mounted() {
    // do nothing
  }

}
</script>
